// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function serializable<T extends { new (...args: Array<any>): {} }>(
  constructor: T
) {
  return class extends constructor {
    _class = constructor.name
  }
}
